<template>
  <div class="template-form-compact">
    <div class="form-section">
      <h6 class="section-title">Параметри паза</h6>
      <div class="input-grid">
        <div class="input-group">
          <label for="p1">Глибина паза</label>
          <input id="p1" :class="{ 'red': detailValidation('P1_') }" @change="fixedLength(detail, 'p1')"
            v-model.number="detail.p1" />
          <div v-if="detailValidation('P1_')" class="error-message">
            {{ detailValidationText('P1_') }}
          </div>
        </div>

        <div class="input-group">
          <label for="p2">Ширина паза</label>
          <input id="p2" :class="{ 'red': detailValidation('P2_') }" @change="fixedLength(detail, 'p2')"
            v-model.number="detail.p2" />
          <div v-if="detailValidation('P2_')" class="error-message">
            {{ detailValidationText('P2_') }}
          </div>
        </div>

        <div class="input-group">
          <label for="p3">Відступ</label>
          <input id="p3" :class="{ 'red': detailValidation('P3_') }" @change="fixedLength(detail, 'p3')"
            v-model.number="detail.p3" />
          <div v-if="detailValidation('P3_')" class="error-message">
            {{ detailValidationText('P3_') }}
          </div>
        </div>

        <div class="input-group">
          <label for="p4">Розташування</label>
          <select id="p4" :class="{ 'red': detailValidation('P4_') }" v-model.number="detail.p4">
            <option value="0">За довжиною</option>
            <option value="1">За шириною</option>
          </select>
          <div v-if="detailValidation('P4_')" class="error-message">
            {{ detailValidationText('P4_') }}
          </div>
        </div>


      </div>
      <div class="input-group" style="margin-top: 1rem;">
        <label for="note">Примітка</label>
        <input id="note" v-model="detail.note" placeholder="Введіть примітку..." />
      </div>
    </div>

  </div>
</template>

<script>
import validation from "@/mixins/BaseTemplate"

export default {
  mixins: [validation],
  props: [
    'detail',
  ],
  computed: {
    resp() {
      return this.$store.state.data.response;
    },
  },
  watch: {
    detail: function (newValue, oldValue) {
      this.$root.$emit('update-detail', this.detail);
    }
  },
  name: "Template_5"
}
</script>


<style scoped>
/* All styles moved to src/assets/scss/general/templates.scss */
</style>